export enum WillingnessToChange {
    NONE = 0,
    VeryLow = 1,
    RatherLow = 2,
    RatherHigh = 3,
    VeryHigh = 4,
}